import http from '@/plugins/axios';
export default {
  listar: function listar(params) {
    return http.apiCore.get('/v1/faq', {
      params: params
    });
  }
};